import type { RecurrenceRule } from "../../../../shared/types";

interface EventItemMetaProps {
  readonly recurrence?: RecurrenceRule;
  readonly reminderMinutes?: number | null;
  readonly eventDate?: string;
}

const DAY_NAMES = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"] as const;

function formatRecurrence(rule: RecurrenceRule, eventDate?: string): string {
  const intervals: Record<string, string> = {
    daily: "jour",
    weekly: "semaine",
    monthly: "mois",
    quarterly: "trimestre",
    semiannual: "semestre",
    yearly: "an",
  };
  const unit = intervals[rule.type];

  if (rule.type === "monthly") {
    const dayOfMonth = eventDate ? new Date(eventDate + "T00:00:00").getDate() : null;
    const dayPart = dayOfMonth ? ` ${dayOfMonth} du` : "";
    return rule.interval === 1
      ? `Chaque${dayPart} mois`
      : `Tous les ${rule.interval} mois${dayPart ? ` (le ${dayOfMonth})` : ""}`;
  }

  const base = rule.interval === 1
    ? `Chaque ${unit}`
    : `Chaque ${rule.interval} ${unit.endsWith("s") ? unit : `${unit}s`}`;

  if (rule.type === "weekly" && rule.daysOfWeek && rule.daysOfWeek.length > 0) {
    const dayLabels = rule.daysOfWeek.map((d) => DAY_NAMES[d]).join(", ");
    return `${base} (${dayLabels})`;
  }
  return base;
}

function formatReminder(minutes: number | null): string {
  if (!minutes) return "";
  if (minutes < 60) return `Rappel ${minutes} min avant`;
  const hours = minutes / 60;
  return `Rappel ${hours}h avant`;
}

export function EventItemMeta({
  recurrence,
  reminderMinutes,
  eventDate,
}: EventItemMetaProps) {
  return (
    <>
      {recurrence && (
        <div className="text-xs text-ink-muted">
          {formatRecurrence(recurrence, eventDate)}
          {recurrence.endDate && ` jusqu'au ${recurrence.endDate}`}
        </div>
      )}

      {reminderMinutes && (
        <div className="text-xs text-ink-muted">
          {formatReminder(reminderMinutes)}
        </div>
      )}
    </>
  );
}
